import { skipToken, useQuery } from "@tanstack/react-query";
import {
  type AvailableTerminalDto,
  getMerchantsOrbitLAvailableTerminals,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const AVAILABLE_TERMINALS_QUERY_KEY = "AVAILABLE_TERMINALS";

export const availableTerminalsKeys = {
  all: [AVAILABLE_TERMINALS_QUERY_KEY],
  byPrefix: (prefix?: string) => [...availableTerminalsKeys.all, prefix],
};

type SearchParams = {
  serialNumberPrefix?: string;
  enabled?: boolean;
};

export const useSearchAvailableTerminalsQuery = ({
  serialNumberPrefix,
  enabled = true,
}: SearchParams) =>
  useQuery<Array<AvailableTerminalDto>>({
    queryKey: availableTerminalsKeys.byPrefix(serialNumberPrefix),
    queryFn:
      enabled && serialNumberPrefix != null
        ? processResponseWithApiProblemDetails(() =>
            getMerchantsOrbitLAvailableTerminals(serialNumberPrefix),
          )
        : skipToken,
  });
